<div class="container-fluid">

    <!-- ====================================================== -->
    <!-- CONTENEDOR PRINCIPAL -->
    <!-- ====================================================== -->

    <div class="signature-container">

        <!-- HEADER -->

        <div class="signature-header">

            <div>
                <h5 class="signature-title">
                    Tamaños de firma
                </h5>

                <p class="signature-subtitle">
                    Administra los tamaños disponibles para las imágenes de firma.
                </p>
            </div>


            <button
                type="button"
                class="btn btn-primary btn-add-signature"
                (click)="openModalAdd()">

                <i class="fa-solid fa-plus me-2"></i>

                Agregar

            </button>

        </div>


        <!-- TABLA -->

        <div class="signature-content">

            <app-paginacion
                [currentPage]="currentPage"
                [totalItems]="totalItems"
                [selectedPageSize]="pageSize"
                [paginatedData]="currentItems"
                [headers]="tableHeaders"
                [actions]="customActions"
                (pageChange)="onPageChange($event)"
                (pageSizeChange)="onPageSizeChange($event)"
                [loading]="spinner">
            </app-paginacion>

        </div>

    </div>

</div>


<!-- ========================================================== -->
<!-- MODAL -->
<!-- ========================================================== -->

<ng-template #modalSignatureSize let-modal>

    <!-- ====================================================== -->
    <!-- HEADER -->
    <!-- ====================================================== -->

    <div class="modal-header signature-modal-header">

        <div>

            <h5 class="modal-title mb-1">

                {{
                    isEdition
                        ? 'Editar tamaño firma'
                        : 'Agregar tamaño firma'
                }}

            </h5>

            <small class="text-muted">
                Configura las dimensiones de la imagen de firma.
            </small>

        </div>


        <button
            type="button"
            class="btn-close"
            aria-label="Cerrar"
            (click)="modal.dismiss('Cross click')">
        </button>

    </div>


    <!-- ====================================================== -->
    <!-- BODY -->
    <!-- ====================================================== -->

    <div class="modal-body signature-modal-body">


        <!-- ================================================== -->
        <!-- VISTA PREVIA -->
        <!-- ================================================== -->

        <div class="preview-section">

            <div class="section-header">

                <div class="section-icon">
                    <i class="fa-regular fa-image"></i>
                </div>

                <div>

                    <h6 class="section-title">
                        Vista previa
                    </h6>

                    <p class="section-description">
                        Visualiza cómo se mostrará la imagen con las dimensiones configuradas.
                    </p>

                </div>

            </div>


            <!-- PREVIEW -->

            <div class="preview-wrapper">

                <div
                    class="preview-container"
                    [style]="scaled
                        ? getStyleContenedorImg(scaled)
                        : 'text-align: center;'">


                    <!-- IMAGEN CON ESCALA -->

                    <img
                        [src]="imagenUrl"
                        alt="Vista previa de la firma"
                        [style]="scaled ? getStyleString(scaled) : null"
                        *ngIf="existeImagen"
                        class="preview-image">


                    <!-- IMAGEN DEFAULT -->

                    <img
                        [src]="imagenUrl"
                        alt="Vista previa de la firma"
                        *ngIf="!existeImagen"
                        class="preview-image-default">

                </div>

            </div>


            <!-- INFORMACIÓN -->

            <div
                class="preview-info"
                *ngIf="existeImagen && scaled">

                <div class="dimension-summary">

                    <div class="dimension-item">

                        <span class="dimension-label">
                            Ancho
                        </span>

                        <strong>
                            {{ scaled.width }} px
                        </strong>

                    </div>


                    <div class="dimension-item">

                        <span class="dimension-label">
                            Alto
                        </span>

                        <strong>
                            {{ scaled.height }} px
                        </strong>

                    </div>


                    <div class="dimension-item">

                        <span class="dimension-label">
                            Escala
                        </span>

                        <strong>
                            {{ scaled.scale }}%
                        </strong>

                    </div>

                </div>


                <div class="preview-note">

                    <i class="fa-solid fa-circle-info"></i>

                    <span>
                        La imagen no se guarda, únicamente se utiliza como
                        referencia para la escalabilidad y configuración.
                    </span>

                </div>

            </div>

        </div>


        <!-- ================================================== -->
        <!-- ARCHIVO -->
        <!-- ================================================== -->

        <div class="upload-section">

            <div class="section-header">

                <div class="section-icon upload-icon">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                </div>

                <div>

                    <h6 class="section-title">
                        Imagen de referencia
                    </h6>

                    <p class="section-description">
                        Selecciona una imagen PNG para comprobar el tamaño.
                    </p>

                </div>

            </div>


            <app-file-upload
                #fileUpload
                (fileSelected)="handleFiles($event)"
                [multiple]="false"
                [extension]="['png']"
                [maxFiles]="1">
            </app-file-upload>

        </div>


        <!-- ================================================== -->
        <!-- FORMULARIO -->
        <!-- ================================================== -->

        <form
            [formGroup]="formSignatureSize"
            class="signature-form">


            <!-- ================================================= -->
            <!-- CONFIGURACIÓN -->
            <!-- ================================================= -->

            <div class="form-section">

                <div class="section-header">

                    <div class="section-icon config-icon">
                        <i class="fa-solid fa-sliders"></i>
                    </div>

                    <div>

                        <h6 class="section-title">
                            Configuración
                        </h6>

                        <p class="section-description">
                            Define el nombre y las dimensiones de la firma.
                        </p>

                    </div>

                </div>


                <!-- NOMBRE -->

                <div class="mb-3">

                    <label class="form-label">
                        Nombre
                    </label>

                    <input
                        type="text"
                        class="form-control"
                        placeholder="Ej: Firma estándar - documento A4"
                        formControlName="nombre" />
                    <app-error-message
                            [control]="formSignatureSize.get('nombre')"
                            errorKey="required"
                            message="El nombre es obligatorio">
                        </app-error-message>

                </div>


                <!-- NOMBRE CORTO -->

                <div class="mb-3">

                    <label class="form-label">
                        Nombre corto
                    </label>

                    <input
                        type="text"
                        class="form-control"
                        placeholder="Ej: estandarA4"
                        formControlName="nombre_corto" readonly="true"/>
                        <app-error-message
                            [control]="formSignatureSize.get('nombre_corto')"
                            errorKey="required"
                            message="El nombre corto es obligatorio">
                        </app-error-message>

                </div>


                <!-- DIMENSIONES -->

                <div class="row g-3">

                    <div class="col-12 col-md-6">

                        <label class="form-label">
                            Ancho
                        </label>

                        <div class="input-group">

                            <input
                                type="text"
                                class="form-control"
                                placeholder="Ej: 150"
                                formControlName="width" readonly="true"/>

                            <span class="input-group-text">
                                px
                            </span>
                            

                        </div>
                        <app-error-message
                            [control]="formSignatureSize.get('width')"
                            errorKey="required"
                            message="El ancho es obligatorio">
                        </app-error-message>

                    </div>


                    <div class="col-12 col-md-6">

                        <label class="form-label">
                            Alto
                        </label>

                        <div class="input-group">

                            <input
                                type="text"
                                class="form-control"
                                placeholder="Ej: 80"
                                formControlName="height"  readonly="true"/>

                            <span class="input-group-text">
                                px
                            </span>

                        </div>
                        <app-error-message
                            [control]="formSignatureSize.get('height')"
                            errorKey="required"
                            message="El alto es obligatorio">
                        </app-error-message>

                    </div>

                </div>

            </div>


            <!-- ================================================= -->
            <!-- VISIBILIDAD -->
            <!-- ================================================= -->

            <div
                class="visibility-section"
                [class.public-mode]="formSignatureSize.get('publica')?.value"
                *ngIf="accesUser">


                <div class="visibility-info">


                    <!-- ICONO -->

                    <div class="visibility-icon">

                        <i
                            class="fa-solid"
                            [ngClass]="
                                formSignatureSize.get('publica')?.value
                                    ? 'fa-globe'
                                    : 'fa-lock'
                            ">
                        </i>

                    </div>


                    <!-- TEXTO -->

                    <div>

                        <div class="visibility-title">

                            Visibilidad

                            <span
                                class="visibility-badge"
                                [class.badge-public]="formSignatureSize.get('publica')?.value"
                                [class.badge-private]="!formSignatureSize.get('publica')?.value">

                                {{
                                    formSignatureSize.get('publica')?.value
                                        ? 'Pública'
                                        : 'Privada'
                                }}

                            </span>

                        </div>


                        <small class="visibility-description">

                            {{
                                formSignatureSize.get('publica')?.value
                                    ? 'Esta firma podrá ser utilizada por otros usuarios.'
                                    : 'Esta firma solo estará disponible para su propietario.'
                            }}

                        </small>

                    </div>

                </div>


                <!-- SWITCH -->

                <label class="modern-switch">

                    <input
                        type="checkbox"
                        id="publica"
                        formControlName="publica">

                    <span class="slider"></span>

                </label>

            </div>

        </form>

    </div>


    <!-- ====================================================== -->
    <!-- FOOTER -->
    <!-- ====================================================== -->

    <div class="modal-footer signature-modal-footer">

        <button
            type="button"
            class="btn btn-light"
            (click)="modal.close('Cerrar click')">

            Cerrar

        </button>


        <button
            type="button"
            class="btn btn-primary px-4"
            (click)="action()">

            <i
                class="fa-solid me-2"
                [ngClass]="isEdition ? 'fa-check' : 'fa-plus'">
            </i>

            {{ !isEdition ? 'Agregar' : 'Actualizar' }}

        </button>

    </div>

</ng-template>